var _rect, _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwitchLeftAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 32,
    viewBox: "0 0 53 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: 2,
    width: 49,
    height: 28,
    rx: 14,
    transform: "matrix(-1 0 0 1 49 0)",
    stroke: "#0046AD",
    strokeWidth: 4
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    transform: "matrix(-1 0 0 1 26 6)",
    fill: "#0046AD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 26C21.5228 26 26 21.5228 26 16C26 10.4772 21.5228 6 16 6C10.4772 6 6 10.4772 6 16C6 21.5228 10.4772 26 16 26Z",
    fill: "#ED8103"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0213 18.9517C15.7146 18.9517 15.4746 18.8584 15.3012 18.6717C15.1279 18.4851 15.0212 18.2117 14.9812 17.8517L14.3412 11.0117C14.2746 10.4117 14.3879 9.93172 14.6812 9.57172C14.9746 9.19839 15.4213 9.01172 16.0213 9.01172C16.5946 9.01172 17.0279 9.19839 17.3212 9.57172C17.6146 9.93172 17.7279 10.4117 17.6612 11.0117L17.0212 17.8517C16.9812 18.2117 16.8746 18.4851 16.7012 18.6717C16.5412 18.8584 16.3146 18.9517 16.0213 18.9517ZM16.0213 23.3917C15.4879 23.3917 15.0612 23.2317 14.7413 22.9117C14.4346 22.5917 14.2812 22.1784 14.2812 21.6717C14.2812 21.1784 14.4346 20.7784 14.7413 20.4717C15.0612 20.1517 15.4879 19.9917 16.0213 19.9917C16.5546 19.9917 16.9679 20.1517 17.2612 20.4717C17.5679 20.7784 17.7212 21.1784 17.7212 21.6717C17.7212 22.1784 17.5679 22.5917 17.2612 22.9117C16.9679 23.2317 16.5546 23.3917 16.0213 23.3917Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchLeftAlert);
export default __webpack_public_path__ + "static/media/switch_left_alert.d628619c8919c4a5a4b1a7b16df693ff.svg";
export { ForwardRef as ReactComponent };